import { render, staticRenderFns } from "./ViewGenCertificado.html?vue&type=template&id=030fa847&external"
import script from "./ViewGenCertificado.vue?vue&type=script&lang=js"
export * from "./ViewGenCertificado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports